import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class PrintService {
  print(printId: string, printTitle: string): void {
    const baseTag = this.getElementTag('base');
    const styles = this.getElementTag('style');
    const links = this.getElementTag('link');
    const printContents = this.getHtmlContents(printId);
    const popupWin = window.open('', '_blank', 'top=0,left=0');

    const printScript = `
		<script defer>
			const isMobile = window.innerWidth >= 0 && window.innerWidth <= 767;
            function triggerPrint() {
                window.removeEventListener('load', triggerPrint, false);
                window.document.body.focus();
                if (isMobile) {
                    setTimeout(() => window.print(), 750);
                } else {
                    window.print();
                    setTimeout(() => window.close(), 500);

                }
            }
            window.addEventListener('load', triggerPrint, false);
        </script>`;

    const htmlDocument = `
		<html lang="en">
			<head>
			  <title>${printTitle}</title>
			  <meta charset="utf-8" />
			  ${baseTag}
			  ${styles}
			  ${links}
			</head>
			<body>
			  ${printContents}
			  ${printScript}
			</body>
		</html>`;

    if (popupWin) {
      popupWin.document.open();
      popupWin.document.write(htmlDocument);
      popupWin.document.close();
    }
  }

  private getElementTag(tagName: string): string {
    const html = [];
    const elements = document.getElementsByTagName(tagName);
    for (let index = 0; index < elements.length; index++) {
      html.push(elements[index].outerHTML);
    }
    return html.join('\r\n');
  }

  private getFormData(data: any): void {
    for (let i = 0; i < data.length; i++) {
      data[i].defaultValue = data[i].value;
      if (data[i].checked) {
        data[i].defaultChecked = true;
      }
    }
  }

  private getHtmlContents(printId: string): any {
    const printContents = document.getElementById(printId);
    if (printContents) {
      const innards = printContents.getElementsByTagName('input');
      this.getFormData(innards);
      const txt = printContents.getElementsByTagName('textarea');
      this.getFormData(txt);

      return printContents.innerHTML;
    }

    return null;
  }
}
